var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconRotateUp = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(2.719 11.914)" },
                React.createElement("path", { strokeDasharray: "4,4", d: "M9-5C4.9-3.6,2.3,0.4,2.5,4.7c0.3,4.3,3.3,8,7.6,8.9" })),
            React.createElement("g", { transform: "translate(0 0)" },
                React.createElement("path", { d: "M23.7,4.2h-6.5v6.5" }),
                React.createElement("path", { d: "M12.8,25.6c5.3,1.2,10.5-2.1,11.7-7.3c0.7-3.3-0.2-6.7-2.6-9.1l-4.7-5" })))));
});
export default IconRotateUp;
//# sourceMappingURL=IconRotateUp.js.map